export function startSilentAuth() {
	return new Promise((resolve) => {
		const iframe = document.createElement("iframe");
		iframe.style.display = "none";
		iframe.src = `${process.env.VUE_APP_SILENT_AUTH_URL}?origin=${window.location.origin}`;
		document.body.appendChild(iframe);

		const timeout = setTimeout(() => {
			cleanup();
			resolve({ success: false });
		}, 5000);

		function cleanup() {
			clearTimeout(timeout);
			window.removeEventListener("message", handler);
			document.body.removeChild(iframe);
		}

		function handler(event) {
			if (event.origin !== new URL(process.env.VUE_APP_SSO_URL).origin) return;

			const data = event.data;
			cleanup();
			resolve(data);
		}

		window.addEventListener("message", handler);
	});
}
